export default __webpack_public_path__ + "static/assets/f1f70649811172a62b7c13cffa64334c.png";